'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

const reports = [
  { year: '2025', title: 'Annual Report 2025', titleKn: 'ವಾರ್ಷಿಕ ವರದಿ 2025', desc: 'Full financial statements, program outcomes, and impact metrics for FY 2024–25.', descKn: 'FY 2024–25 ರ ಸಂಪೂರ್ಣ ಆರ್ಥಿಕ ಹೇಳಿಕೆಗಳು, ಕಾರ್ಯಕ್ರಮ ಫಲಿತಾಂಶಗಳು ಮತ್ತು ಪ್ರಭಾವ ಮಾಪನಗಳು.', size: '4.2 MB', type: 'PDF' },
  { year: '2024', title: 'Annual Report 2024', titleKn: 'ವಾರ್ಷಿಕ ವರದಿ 2024', desc: 'Comprehensive report covering all programs, beneficiaries, and financial transparency.', descKn: 'ಎಲ್ಲಾ ಕಾರ್ಯಕ್ರಮಗಳು, ಫಲಾನುಭವಿಗಳು ಮತ್ತು ಆರ್ಥಿಕ ಪಾರದರ್ಶಕತೆ ಒಳಗೊಂಡ ಸಮಗ್ರ ವರದಿ.', size: '3.8 MB', type: 'PDF' },
  { year: '2023', title: 'Annual Report 2023', titleKn: 'ವಾರ್ಷಿಕ ವರದಿ 2023', desc: 'Year in review — milestones, challenges, and community stories from 2022–23.', descKn: 'ವರ್ಷದ ಪರಿಶೀಲನೆ — 2022–23 ರ ಮೈಲಿಗಲ್ಲುಗಳು, ಸವಾಲುಗಳು ಮತ್ತು ಸಮುದಾಯ ಕಥೆಗಳು.', size: '3.1 MB', type: 'PDF' },
];

const resources = [
  { title: 'Scholarship Application Form', titleKn: 'ವಿದ್ಯಾರ್ಥಿವೇತನ ಅರ್ಜಿ ನಮೂನೆ', desc: 'Apply for merit or need-based scholarships for higher education.', descKn: 'ಉನ್ನತ ಶಿಕ್ಷಣಕ್ಕಾಗಿ ಮೆರಿಟ್ ಅಥವಾ ಅಗತ್ಯ ಆಧಾರಿತ ವಿದ್ಯಾರ್ಥಿವೇತನಕ್ಕೆ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ.', icon: '📝', category: 'Forms', categoryKn: 'ನಮೂನೆಗಳು' },
  { title: 'Volunteer Handbook', titleKn: 'ಸ್ವಯಂಸೇವಕ ಕೈಪಿಡಿ', desc: 'Everything you need to know before joining as a volunteer.', descKn: 'ಸ್ವಯಂಸೇವಕರಾಗಿ ಸೇರುವ ಮೊದಲು ನೀವು ತಿಳಿದುಕೊಳ್ಳಬೇಕಾದ ಎಲ್ಲವೂ.', icon: '📖', category: 'Guides', categoryKn: 'ಮಾರ್ಗದರ್ಶಿಗಳು' },
  { title: 'CSR Partnership Brochure', titleKn: 'CSR ಪಾಲುದಾರಿಕೆ ಕರಪತ್ರ', desc: 'Overview of our CSR programs and partnership opportunities.', descKn: 'ನಮ್ಮ CSR ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ಪಾಲುದಾರಿಕೆ ಅವಕಾಶಗಳ ಅವಲೋಕನ.', icon: '🤝', category: 'Partnerships', categoryKn: 'ಪಾಲುದಾರಿಕೆಗಳು' },
  { title: 'Donation Receipt Template', titleKn: 'ದೇಣಿಗೆ ರಸೀದಿ ಟೆಂಪ್ಲೇಟ್', desc: 'Sample 80G donation receipt format for your records.', descKn: 'ನಿಮ್ಮ ದಾಖಲೆಗಳಿಗಾಗಿ ಮಾದರಿ 80G ದೇಣಿಗೆ ರಸೀದಿ ಸ್ವರೂಪ.', icon: '🧾', category: 'Legal', categoryKn: 'ಕಾನೂನು' },
  { title: 'Program Impact Data 2025', titleKn: 'ಕಾರ್ಯಕ್ರಮ ಪ್ರಭಾವ ಡೇಟಾ 2025', desc: 'Detailed program-wise impact data and beneficiary statistics.', descKn: 'ವಿವರವಾದ ಕಾರ್ಯಕ್ರಮ-ವಾರಿ ಪ್ರಭಾವ ಡೇಟಾ ಮತ್ತು ಫಲಾನುಭವಿ ಅಂಕಿಅಂಶಗಳು.', icon: '📊', category: 'Data', categoryKn: 'ಡೇಟಾ' },
  { title: 'Media Kit', titleKn: 'ಮಾಧ್ಯಮ ಕಿಟ್', desc: 'Logo, brand guidelines, and press materials for media use.', descKn: 'ಮಾಧ್ಯಮ ಬಳಕೆಗಾಗಿ ಲೋಗೋ, ಬ್ರ್ಯಾಂಡ್ ಮಾರ್ಗಸೂಚಿಗಳು ಮತ್ತು ಪ್ರೆಸ್ ಸಾಮಗ್ರಿಗಳು.', icon: '🎨', category: 'Media', categoryKn: 'ಮಾಧ್ಯಮ' },
];

export default function ResourcesPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const kn = language === 'kn';

  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main className="pt-24">
        <section className="hero-gradient py-20 px-6 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className={`text-4xl sm:text-5xl font-bold mb-4 ${kn ? 'font-kannada' : ''}`}>
              {t?.resources?.heroTitle} <span className="text-saffron-light">{t?.resources?.heroHighlight}</span>
            </h1>
            <p className={`text-white/75 text-lg max-w-2xl mx-auto ${kn ? 'font-kannada' : ''}`}>{t?.resources?.heroSubtitle}</p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <div className="mb-12">
              <div className="section-divider w-16 mb-6"></div>
              <h2 className={`text-3xl font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{t?.resources?.annualReports}</h2>
            </div>
            <div className="space-y-4">
              {reports?.map((r) => (
                <div key={r?.year} className="flex items-center justify-between gap-6 p-6 bg-white rounded-2xl border border-neutral-100 shadow-card hover-lift">
                  <div className="flex items-center gap-5">
                    <div className="w-14 h-14 rounded-2xl bg-crimson-pale flex items-center justify-center">
                      <span className="text-crimson font-bold text-sm">{r?.year}</span>
                    </div>
                    <div>
                      <h3 className={`font-bold text-neutral-900 ${kn ? 'font-kannada' : ''}`}>{kn ? r?.titleKn : r?.title}</h3>
                      <p className={`text-neutral-500 text-sm mt-0.5 ${kn ? 'font-kannada' : ''}`}>{kn ? r?.descKn : r?.desc}</p>
                      <span className="text-neutral-400 text-xs">{r?.type} · {r?.size}</span>
                    </div>
                  </div>
                  <button className={`flex-shrink-0 flex items-center gap-2 px-5 py-2.5 btn-indigo rounded-full text-sm font-semibold ${kn ? 'font-kannada' : ''}`}>
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/></svg>
                    {t?.resources?.download}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-surface-muted">
          <div className="max-w-5xl mx-auto px-6">
            <div className="mb-10">
              <h2 className={`text-3xl font-bold text-indigo mb-2 ${kn ? 'font-kannada' : ''}`}>{t?.resources?.downloadsTitle}</h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {resources?.map((res) => (
                <div key={res?.title} className="bg-white rounded-2xl p-6 shadow-card hover-lift card-hover">
                  <div className="text-3xl mb-3">{res?.icon}</div>
                  <span className={`inline-block px-2 py-0.5 bg-saffron-pale text-saffron text-xs font-semibold rounded mb-2 ${kn ? 'font-kannada' : ''}`}>{kn ? res?.categoryKn : res?.category}</span>
                  <h3 className={`font-bold text-neutral-900 mb-2 ${kn ? 'font-kannada' : ''}`}>{kn ? res?.titleKn : res?.title}</h3>
                  <p className={`text-neutral-500 text-sm mb-4 ${kn ? 'font-kannada' : ''}`}>{kn ? res?.descKn : res?.desc}</p>
                  <button className={`text-saffron text-sm font-semibold hover:underline flex items-center gap-1 ${kn ? 'font-kannada' : ''}`}>
                    {t?.resources?.download}
                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/></svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-indigo text-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className={`text-3xl font-bold mb-4 ${kn ? 'font-kannada' : ''}`}>{kn ? 'ಆರ್ಥಿಕ ಪಾರದರ್ಶಕತೆ' : 'Financial Transparency'}</h2>
            <p className={`text-white/70 mb-8 max-w-2xl mx-auto ${kn ? 'font-kannada' : ''}`}>{kn ? 'ನಾವು ಸಂಪೂರ್ಣ ಆರ್ಥಿಕ ಪಾರದರ್ಶಕತೆಗೆ ಬದ್ಧರಾಗಿದ್ದೇವೆ. ನಮ್ಮ ಲೆಕ್ಕಪತ್ರಗಳನ್ನು ವಾರ್ಷಿಕವಾಗಿ ಪ್ರಮಾಣಿತ CA ಸಂಸ್ಥೆ ಲೆಕ್ಕ ಪರಿಶೋಧನೆ ಮಾಡುತ್ತದೆ.' : 'We are committed to complete financial transparency. Our accounts are audited annually by a certified CA firm and all reports are publicly available.'}</p>
            <div className="grid sm:grid-cols-3 gap-5">
              {[
                { label: kn ? 'ಕಾರ್ಯಕ್ರಮ ವೆಚ್ಚಗಳು' : 'Program Expenses', value: '90%', desc: kn ? 'ನೇರವಾಗಿ ಕಾರ್ಯಕ್ರಮಗಳಿಗೆ' : 'Goes directly to programs' },
                { label: kn ? 'ಆಡಳಿತ ವೆಚ್ಚಗಳು' : 'Admin Costs', value: '10%', desc: kn ? 'ಕಾರ್ಯಾಚರಣೆ ಮತ್ತು ಓವರ್‌ಹೆಡ್' : 'Operations & overhead' },
                { label: kn ? 'ಲೆಕ್ಕ ಪರಿಶೋಧನೆ ಸ್ಥಿತಿ' : 'Audit Status', value: '✓', desc: kn ? 'ವಾರ್ಷಿಕ ಲೆಕ್ಕ ಪರಿಶೋಧನೆ' : 'Annually audited' },
              ]?.map((item) => (
                <div key={item?.label} className="bg-white/10 rounded-2xl p-6 border border-white/10">
                  <div className="text-3xl font-bold text-saffron-light mb-1">{item?.value}</div>
                  <div className={`font-bold text-white text-sm mb-1 ${kn ? 'font-kannada' : ''}`}>{item?.label}</div>
                  <div className={`text-white/50 text-xs ${kn ? 'font-kannada' : ''}`}>{item?.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
